'use client';

import 'swiper/css';
import 'swiper/css/navigation';

import { useSearchParams } from 'next/navigation';
import React, { useEffect } from 'react';

import ListBarUsecase from '@/components/list-bar/ListBarUsecase';
import useCreateQueryString from '@/hooks/useCreateQueryString';
import { SIDEBAR_MENU_LINK } from '@/layouts/sidebar';
// import cachedLocalStorage from '@/libs/localStorage';
import { useRouter } from '@/provider/RouterProvider';
import { useAuth } from '@/provider/UserProvider';

import ListUsecase from './ListUsecase';
import useUseCase from './useUseCase';

enum CategoryKey {
  Hot = 'hot',
  New = 'new',
}

const CATEGORIES = [
  { key: CategoryKey.Hot, title: 'Hot' },
  { key: CategoryKey.New, title: 'New' },
];

const UsecaseNew = () => {
  const [openFilter, setOpenFilter] = React.useState(false);
  const router = useRouter();
  const searchParams = useSearchParams();
  const createQueryString = useCreateQueryString();
  const categoryParam = searchParams.get('category');
  const { isLoginClient } = useAuth();

  // const isFilterNsfwStorage = cachedLocalStorage.getItemStr('isFilterNsfw');
  const isFilterNsfwStorage = false;

  const [isFilterNsfw, setIsFilterNsfw] = React.useState<boolean>(false);

  const { list, loading, currentPage, loadMore } = useUseCase();

  const handleFilterCategory = (key: CategoryKey) => {
    switch (key) {
      case CategoryKey.Hot:
        createQueryString(
          ['category', 'weekViews', 'createdAt'],
          [key, 'DESC', ''],
          { scroll: false },
          ['assetCategory', 'tags', 'tagIds'],
        );
        break;
      case CategoryKey.New:
        createQueryString(
          ['category', 'weekViews', 'createdAt'],
          [key, '', 'DESC'],
          { scroll: false },
          ['assetCategory', 'tags', 'tagIds'],
        );
        break;
      default:
        createQueryString(['category', 'weekViews', 'createdAt'], [key, 'DESC', '']);
        break;
    }
  };

  const handleClearFilter = React.useCallback(() => {
    setOpenFilter(false);
    router.replace(SIDEBAR_MENU_LINK.explore, { scroll: false });
  }, []);

  useEffect(() => {
    if (!isLoginClient || !isFilterNsfwStorage) {
      setIsFilterNsfw(false);
    }
  }, [isLoginClient, isFilterNsfwStorage]);

  // useEffect(() => {
  //   if (isFilterNsfw) {
  //     createQueryString(['nsfw'], [true]);
  //   }
  // }, [isLoginClient, isFilterNsfw]);

  return (
    <div>
      <div className="mx-10 pb-8 pt-[48px] md:mx-[20px] md:py-6">
        <div className="flex items-center pb-6 md:pb-3">
          {CATEGORIES.map((item, index) => (
            <span
              aria-expanded={index > 0}
              key={index}
              aria-checked={categoryParam === item.key || (index === 0 && !categoryParam)}
              onClick={() => handleFilterCategory(item.key)}
              className="cursor-pointer text-[36px] font-bold leading-[1.2] text-gray-400 aria-checked:text-black aria-expanded:ml-6 md:aria-expanded:ml-4 sm:text-[26px]"
            >
              {item.title}
            </span>
          ))}
        </div>
        <div className="">
          <ListBarUsecase
            handleClearFilter={handleClearFilter}
            openFilter={openFilter}
            setOpenFilter={setOpenFilter}
            isFilterNsfw={isFilterNsfw}
            setIsFilterNsfw={setIsFilterNsfw}
          />
          <div className="mt-6">
            <ListUsecase
              openFilter={openFilter}
              setOpenFilter={setOpenFilter}
              list={list}
              loadMore={loadMore}
              currentPage={currentPage}
              // getUseCaseURL={getUseCaseURL}
              loading={loading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsecaseNew;
